"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TertiaryMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatID = _interopRequireDefault(require("../../../utils/formatID"));
var _lodash = require("lodash");
var _NavBar = require("../../NavBar/NavBar");
var _LunaLink = _interopRequireDefault(require("../../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TertiaryMenu = props => {
  const {
    links,
    hasFeatures,
    isOpen,
    mouseLeave,
    Link,
    subNavHeightStyles
  } = props;
  const {
    mouse
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const [open, setOpen] = (0, _react.useState)(null);
  const terMouseLeave = () => {
    setOpen(null);
  };
  const mouseOverFeature = feature => {
    setOpen(feature);
  };
  const navigateWithKeys = (e, id) => {
    //mouseOverWithKeysMegaMenu(e, text);

    //check for enter key
    if (e.keyCode === 13) {
      mouseOverFeature(id);
    }
  };
  const generateLinks = () => {
    return links?.map((link, index) => /*#__PURE__*/_react.default.createElement("div", {
      key: link?.text + " " + index,
      onMouseOver: () => mouseOverFeature(link?.contentfulId),
      onMouseLeave: () => terMouseLeave(),
      onKeyDown: e => navigateWithKeys(e, link?.contentfulId)
      // id={formatID(`${link?.text}-mega-menu-tertiary-title-text`)}
      ,
      className: `ter-right-section__clip ${isOpen ? "ter-right-section__clip--is-open" : ""}`
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      Link: Link,
      tabIndex: mouse ? "" : "0",
      depth: 4
      // id={formatID(`${link?.text}-right-section-link`)}
      ,
      to: link?.url,
      href: link?.href,
      className: `ter-right-section__link ${open === link?.contentfulId ? "ter-right-section__link--is-open" : ""} ${mouse ? "" : "tabFocus"}
          `,
      onClick: () => mouseLeave("click"),
      target: typeof link?.external === 'boolean' ? link?.external ? "_blank" : "_self" : null
    }, /*#__PURE__*/_react.default.createElement("p", {
      // id={formatID(`${link?.text}-mega-menu-item-link-text`)}
      className: `ter-right-section__link--underline ${open === link.contentfulId ? "ter-right-section__link--underline--is-open" : ""}`
    }, link?.text))));
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-right-section tertiary ${isOpen ? "ter-right-section--is-open" : "ter-right-section--is-closed"} ${hasFeatures ? "ter-right-section--is-open--has-features" : ""}`,
    style: {
      ...subNavHeightStyles
    }
  }, generateLinks());
};
exports.TertiaryMenu = TertiaryMenu;